import React from 'react';
import Row from '../../../../shared/components/Row';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { MachineForm } from '../MachineForm';
import { MachineFormValues } from '../MachineFormValues';
import { MachineCreateRequest } from './machine-create/MachineCreateRequest';
import { MachineCreateTask } from './machine-create/MachineCreateTask';
import Alert from 'react-s-alert';
import { PsRoutes } from '../../../../shared/routing/Routes';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';

export class MachineCreate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            machineValues: MachineFormValues.fromCurrentUser(props.currentUser),
        };
    }

    render() {
        const { machineValues } = this.state;
        const initialValues = machineValues.initialValues();

        return (
            <React.Fragment>
                <Row clearfix>
                    <MachineForm
                        title={I18nUtils.tr('TR_NUEVA_MAQUINA')}
                        initialValues={initialValues}
                        onSubmit={this.createMachine}
                    />
                </Row>
            </React.Fragment>
        );
    }

    createMachine = (values) => {
        const request = new MachineCreateRequest(values);

        new MachineCreateTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_MAQUINA_CREADA_CORRECTAMENTE'));
                this.props.navigation.goTo(PsRoutes.MY_CONTRACTORS_MACHINES);
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const MachineCreateContent = connect(mapStateToProps, mapDispatchToProps)(MachineCreate);

MachineCreateContent.propTypes = {};

MachineCreateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/create/MachineCreateContent.jsx